import { Flex as FlexBase } from '@chakra-ui/react'

import styled from '@emotion/styled'

export const FlexRow = styled(FlexBase)`
  flex-direction: row;
`

export const CenterFlexRow = styled(FlexRow)`
  justify-content: center;
  align-items: center;
`

export const FlexCol = styled(FlexBase)`
  flex-direction: column;
`
